<template>
  <!-- 广告图设置 -->
  <div class="advertList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商城管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增资质图片</el-button
        >
      </template>
    </crumbs-bar>
    <div>
      <div class="drawer-header">资质图片</div>
      <div class="wrapLeft">建议尺寸800px*600px按照该比例设置即可</div>
      <el-scrollbar style="height: calc(100vh - 240px)">
        <div class="drawer-form-wrap">
          <div v-for="(item, index) in twoList" :key="index">
            <div class="wrap">
              <label class="label">资质图片名称</label>
              <el-input v-model="item.Name" class="itemInput"></el-input>
              <span class="labelspan" @click="deleteSPan(index)">删除</span>
            </div>
            <upload
              @fileChange="uploadSortImg($event, index)"
              accept="image/jpg,image/jpeg,image/png"
              :multiple="true"
            ></upload>
            <img-view
              style="margin-left: 20px"
              :imgList="[{ url: item.img, id: index }]"
            ></img-view>
          </div>
          <div class="wrapLeft">
            <el-button
              type="primary"
              @click="addZi"
              icon="el-icon-circle-plus-outline"
              >添加</el-button
            >
          </div>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "zzgl",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        status: "9",
      },
      // 二级分类列表
      twoList: [],
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: 0,
        title: "",
        appName: "",
      },
      sortImg: "", // 分类图片，用于本地显示
      addFormRule: {
        rank: [mustFill],
        parentId: [mustFill],
      },
      goodsSort: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.twoList = [];
    this.getTableData();
  },
  methods: {
    // 添加
    addZi() {
      this.twoList.push({ Name: "", img: "", FilePath: "" });
    },
    // 删除
    deleteSPan(index) {
      this.twoList.splice(index, 1);
    },
    /**获取表格 */
    getTableData() {
      let data = {
        entId: window.localStorage.getItem("entId"),
      };
      this.$request({
        url: "/Management/MemberAdmin/GetEnterpriseData",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            res.dataList.forEach((i) => {
              this.twoList.push({
                img: this.$setImgUrl(i.FilePath),
                Name: i.Name,
                FilePath: i.FilePath,
              });
            });
            // this.changeArr(res.list || []);
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            id: row.id,
            status: status,
          };
          this.$request({
            url: "Navigation/UpdateNavigationStatusDal",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {
          this.addForm[key] = row[key];
        }
        this.sortImg = this.$setImgUrl(row.icon);
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: "AdvertList",
        pcLink: "",
        appType: "0",
        appGoods: "",
        appMode: "",
        appWebUrl: "",
        appGoodsSort: "",
        appGoodsSortName: "",
        appExpert: "",
        appName: "",
      };
      this.sortImg = "";
      this.addDrawer = false;
    },

    // 上传分类图片
    uploadSortImg(file, index) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.twoList[index].img = this.$setImgUrl(res.message);
              this.twoList[index].FilePath = res.message;
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /**提交新增分类 */
    submit() {
      let data = [];
      this.twoList.forEach((item) => {
        data.push({
          Name: item.Name,
          FilePath: item.FilePath,
        });
      });
      this.$request({
        url: "/Management/MemberAdmin/SaveEnterpriseData",
        method: "post",
        data: {
          EnterpriseList: data,
        },
        headers: {
          Auth: window.localStorage.getItem("auth"),
          ContentType: "application/json",
        },
      }).then((res) => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.advertList {
  width: 100%;
  height: 100%;
}
.wrapLeft {
  margin-top: 20px;
  font-size: 16px;
  margin-left: 20px;
}
.wrap {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.label {
  width: 120px;
  cursor: pointer;
}
.labelspan {
  width: 60px;
  margin-left: 10px;
  cursor: pointer;
  color: red;
}
.itemInput {
  width: 200px;
}
</style>
